import React, { useMemo } from 'react';
import { CSSTransition } from 'react-transition-group';
import {
  NotificationPosition,
  NotificationType,
} from '../../libraries/Notification';
import { getMergedClassNames } from '../../utils/HTMLutils';
import './Notification.scss';
const rootClassName = 'component-notification';

interface NotificationProps {
  position?: NotificationPosition;
  type?: NotificationType;
  count?: number;
  verticalOuter?: number;
  horizontalOuter?: number;
  className?: string;
  children: React.ReactNode;
}

export default function Notification(props: NotificationProps) {
  const getProps = () => {
    const p = {
      className: getMergedClassNames([
        `${rootClassName}-outer`,
        props.className,
      ]),
    };
    return p;
  };

  const label = useMemo(() => {
    if (!props.count) return 0;
    if (props.count < 0) return '!';
    return props.count;
  }, [props.count]);

  return (
    <div {...getProps()}>
      {props.children}
      <CSSTransition
        in={!!label}
        classNames={rootClassName}
        timeout={300}
        unmountOnExit
      >
        <div
          className={`${rootClassName} ${rootClassName}-${props.position} ${rootClassName}-${props.type}`}
          style={{
            top: String(props.position).match(/top/)
              ? `${0 - (props.verticalOuter || 0)}px`
              : 'unset',
            right: String(props.position).match(/right/)
              ? `${0 - (props.horizontalOuter || 0)}px`
              : 'unset',
            left: String(props.position).match(/left/)
              ? `${0 - (props.horizontalOuter || 0)}px`
              : 'unset',
            bottom: String(props.position).match(/bottom/)
              ? `${0 - (props.verticalOuter || 0)}px`
              : 'unset',
          }}
        >
          {label}
        </div>
      </CSSTransition>
    </div>
  );
}

Notification.defaultProps = {
  type: NotificationType.Error,
  position: NotificationPosition.TopRight,
  verticalOuter: 10,
  horizontalOuter: 10,
};
